// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loading-circle {
  animation: 2s linear infinite both loading-circle_svg;
}
.loading-circle-svg-circle {
  animation: 1.4s ease-in-out infinite both circle__svg-circle;
  fill: transparent;
  stroke-dasharray: 285;
  stroke-linecap: round;
  stroke-width: 10px;
  stroke: rgb(var(--color-primary));
  transform-origin: 50% 50%;
}
.text-indigo-500 .loading-circle-svg-circle {
  stroke: rgb(var(--color-primary));
}
.text-white .loading-circle-svg-circle {
  stroke: #fff;
}
@keyframes loading-circle_svg {
0% {
    transform: rotateZ(0deg);
}
100% {
    transform: rotateZ(360deg);
}
}
@keyframes circle__svg-circle {
0%,
  25% {
    stroke-dashoffset: 280;
    transform: rotate(0);
}
50%,
  75% {
    stroke-dashoffset: 75;
    transform: rotate(45deg);
}
100% {
    stroke-dashoffset: 280;
    transform: rotate(360deg);
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
